import { render, staticRenderFns } from "./NotSupported.vue?vue&type=template&id=92cb3e74&scoped=true&"
import script from "./NotSupported.vue?vue&type=script&lang=js&"
export * from "./NotSupported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cb3e74",
  null
  
)

export default component.exports